<template>
  <v-container v-if="artist">
    <v-layout row wrap v-if="purchaseSuccess">
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <v-alert :color="$config.colors.primary" :value="true" type="success">
          <div>{{ $lang.thankYouForYourPurchase(purchasedAlbum.title) }}</div>
          <div>
            <v-btn small target="_blank" :href="makeDownloadUrl" :class="['mx-0', 'mt-2']" :title="$lang.downloadAlbum(purchasedAlbum.title)">{{ $lang.downloadAlbum(purchasedAlbum.title) }}</v-btn>
          </div>
        </v-alert>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <static-page-content slug="music" />
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="artist.albums.length" align-space-between fill-height>
      <v-flex lg4 xs12 v-for="(album, index) in artist.albums" :key="index" :class="['pa-2']">
        <v-card @click.capture="gtagEvent('view', 'album', album.title)" ripple :to="`/music/${album.slug}`" :title="$lang.viewRelease(album.title)">
          <v-card-text :class="['pa-1']">
            <v-img :lazy-src="$config.replacementImage" :src="album.art" :class="['elevation-12']" />
            <div :class="['caption', 'mt-2', 'text-uppercase', 'text-xs-center', 'font-weight-medium']">
              <div v-html="album.title" :class="['ellipsis']" />
              <div v-html="$lang.albumInProgress(getAlbumDetails(album.slug))" />
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <featured-video />
    </v-layout>
    <news-ticker />
  </v-container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'PageMusic',
  mixins: [
    methods
  ],
  data () {
    return {
      artist: null,
      purchasedAlbum: JSON.parse(localStorage.getItem('purchase'))
    }
  },
  mounted () {
    this.getArtist()
  },
  computed: {
    purchaseSuccess () {
      return window.location.href.indexOf(this.$config.payPalReturnPage.split('?')[1]) > -1 && this.purchasedAlbum
    },
    makeDownloadUrl () {
      return this.getAlbumDetails(this.purchasedAlbum.albumSlug).download
      // return this.$config.album[this.purchasedAlbum.albumSlug]
    }
  },
  methods: {
    setArtist (data) {
      this.artist = data
    },
    getArtist () {
      const slug = this.$route.path
      const cachedData = this.retrieveCachedData('music', slug)
      const url = this.getBCRoute('artist')
      if (cachedData) {
        return this.setArtist(cachedData)
      }
      this.$http({
        url,
        method: 'POST',
        data: {
          artist: this.$config.bcArtistSlug
        }
      }).then(response => {
        const data = response.data.data
        data.albums.map(album => {
          album.art = `/static/images/${album.slug}.jpg`
          return album
        })
        this.setArtist(data)
        this.cacheData(slug, 'music', data)
      }).catch(error => {
        console.error(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/music.vue